const navigationHu = {
    "menu_editor": "Étlap",
    "payment_settings": "Fizetési beállítások",
    "user_management": "Felhasználók",
    "settings": "Beállítások",
    "logout": "Kijelentkezés",
    "subscription": "Előfizetés",
    "new_restaurant": "Új étterem létrehozása",
    "privacy_policy": "Adatvédelmi tájékoztató",
    "terms_and_conditions": "Általános szerződési feltételek",
    "statistics": "Statisztikák",
    "mozrest": "Review Manager",
    "signup": "Regisztráció",
};

export default navigationHu;